import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";

export default function MainLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen h-[100dvh] bg-white overflow-hidden">
      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col h-full overflow-y-auto bg-grey-50">
        {/* Mobile top bar */}
        <div className="flex md:hidden items-center gap-3 px-4 h-14 flex-shrink-0 bg-[#2E3037] sticky top-0 z-30">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-[#C2C6D5] hover:text-white transition-colors p-1"
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
          <span className="font-bold text-white text-lg tracking-tight">AnalystBro</span>
        </div>

        {children ?? <Outlet />}
      </div>
    </div>
  );
}
